import React, { useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import { Outlet } from "react-router-dom"; 
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ signout, user }) => {
    const [open, setOpen] = useState(true);
    const toggleDrawer = () => setOpen(!open);

    const [selection, setSelection] = useState({ calculation: "", model: "" });

    return (
        <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CssBaseline />            
            <Header signout={signout} user={user}  open={open} onSelectionChange={setSelection} />
            <Box sx={{ display: "flex", flexGrow: 1 }}>
                <Sidebar open={open} toggleDrawer={toggleDrawer} />
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 0,
                        transition: "margin 0.3s ease-in-out",
                        minWidth: 0,
                        overflow: "hidden"
                    }}
                >
                    <Outlet context={{ selection, setSelection }} />
                </Box>
            </Box>
        </Box>
    );
};

export default Layout;